import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/StateBox' /* webpackChunkName: "StateBox" */),
    import('./viewer/StateBox.controller' /* webpackChunkName: "StateBox" */),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('StateBox', UiTypes),
};

export default entry;
